import { openDB } from 'idb';

const DB_NAME = 'glb-thumbnail-cache';
const STORE_NAME = 'thumbnails';
const DB_VERSION = 1;

// IndexedDB 초기화
async function initDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'key' });
      }
    },
  });
}

/**
 * 썸네일을 캐시에 저장
 * @param {string} fileKey - 파일 키 (S3 키 또는 고유 식별자)
 * @param {string} thumbnailData - Base64 인코딩된 이미지 데이터
 * @param {string} lastModified - 파일 수정 날짜
 */
export async function saveThumbnailToCache(fileKey, thumbnailData, lastModified) {
  try {
    const db = await initDB();
    await db.put(STORE_NAME, {
      key: fileKey,
      thumbnail: thumbnailData,
      lastModified: lastModified,
      createdAt: Date.now()
    });
  } catch (error) {
    console.error('썸네일 캐시 저장 실패:', error);
  }
}

/**
 * 캐시에서 썸네일 가져오기
 * @param {string} fileKey - 파일 키
 * @param {string} lastModified - 파일 수정 날짜
 * @returns {Promise<string|null>} - 썸네일 데이터 또는 null
 */
export async function getThumbnailFromCache(fileKey, lastModified) {
  try {
    const db = await initDB();
    const cached = await db.get(STORE_NAME, fileKey);

    if (!cached) {
      return null;
    }

    // 파일이 수정되었으면 캐시 무효화
    if (cached.lastModified !== lastModified) {
      await db.delete(STORE_NAME, fileKey);
      return null;
    }

    return cached.thumbnail;
  } catch (error) {
    console.error('썸네일 캐시 조회 실패:', error);
    return null;
  }
}

/**
 * 오래된 캐시 정리 (30일 이상)
 */
export async function cleanOldCache() {
  try {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const allKeys = await store.getAllKeys();

    const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);

    for (const key of allKeys) {
      const record = await store.get(key);
      if (record && record.createdAt < thirtyDaysAgo) {
        await store.delete(key);
      }
    }

    await tx.done;
  } catch (error) {
    console.error('오래된 캐시 정리 실패:', error);
  }
}

/**
 * 전체 캐시 삭제
 */
export async function clearAllCache() {
  try {
    const db = await initDB();
    await db.clear(STORE_NAME);
  } catch (error) {
    console.error('캐시 전체 삭제 실패:', error);
  }
}
